import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyMissedCallTexts = lazy(() => import('./svg-components/missed-call-texts'));

const MissedCallTexts = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyMissedCallTexts {...rest} />
  </Suspense>
);

export default MissedCallTexts;
